import { FC, useEffect, useState } from 'react';
import { Search } from 'components/Search';
import { BellIcon } from 'components/icons/BellIcon';
import { InfoCircleIcon } from 'components/icons/InfoCircleIcon';
import { BellDotIcon } from 'components/icons/BellDotIcon';
import { RootState } from 'store';
import { useDispatch, useSelector } from 'react-redux';
import { Menu } from 'components/Menu';
import { HeaderMenuItem } from 'components/Menu/HeaderMenuItem';
import { SettingIcon } from 'components/icons/SettingIcon';
import { HamburgerMenuIcon } from 'components/icons/HamburgerMenuIcon';
import { handleSidebarOpen } from 'store/appSlice';
import { useLocation, useNavigate } from 'react-router-dom';
import useActiveWorkspace from 'hooks/useActiveWorkspace';

interface HeaderProps {
  query?: string;
  onSearch?: () => void;
  onSearchTerms?: (value: string) => void;
  darkTheme?: boolean;
  disabled?: boolean;
}

export const Header: FC<HeaderProps> = () => {
  const [query, setQuery] = useState<string>('');

  const dispatch = useDispatch();
  const notifications = useSelector((state: RootState) => state.app.notifications);
  const sidebarOpen = useSelector((state: RootState) => state.app.sidebarOpen);
  const userData = useSelector((state: RootState) => state.user.user);
  const navigate = useNavigate();
  const location = useLocation();
  const { workspaceId, activeWorkspace } = useActiveWorkspace();

  useEffect(() => {
    setQuery(location.state?.query || '');
  }, [location]);

  return (
    <div className="flex flex-shrink-0 items-center text-white bg-gray-header min-h-[44px] max-h-11 overflow-y-hidden shadow-sm font-lato">
      <div className="flex items-center 2xl:flex-1 lg:min-w-[220px] xl:min-w-[260px] px-2">
        <HamburgerMenuIcon
          className="cursor-pointer fill-white"
          onClick={() => dispatch(handleSidebarOpen(!sidebarOpen))}
        />
      </div>
      <div className="flex items-center flex-2 lg:max-w-[732px] w-full">
        <Search
          disabled={false}
          placeholder="Search"
          query={query}
          onSearchTerms={(value: string) => setQuery(value)}
          onSearch={() =>
            navigate(`/workspace/${workspaceId}/search`, {
              state: {
                query
              }
            })
          }
        />
      </div>
      <div className="flex items-center 2xl:flex-1 ml-auto min-w-auto px-4 shrink-0 justify-end">
        <div className="w-[26px] h-[26px] flex items-center justify-center hover:bg-white hover:bg-opacity-20 mr-3 p-[3px] rounded-[4px] cursor-pointer">
          <InfoCircleIcon className="w-5 h-5" fill="currentColor" />
        </div>
        <Menu
          dropdownHeader={
            <>
              <div className="flex items-center justify-between w-full text-black px-4 py-[7px] font-black text-lg border-line">
                Notification
                <div className="w-9 h-9 flex items-center justify-center cursor-pointer text-gray-800 text-opacity-70 hover:text-opacity-100">
                  <SettingIcon className="w-6 h-6" />
                </div>
              </div>
              <div className="my-2 border-b border-gray-popup" />
            </>
          }
          menus={notifications}
          MenuItem={HeaderMenuItem}
          align="right"
          position="absolute"
          width={400}
          notificationMenu={true}
          additionalClasses="w-fit"
        >
          <div className="w-[33px] h-[33px] flex items-center justify-center hover:bg-white hover:bg-opacity-20 mr-3 p-[3px] rounded-[4px] cursor-pointer">
            {notifications.length ? (
              <BellDotIcon className="w-6 h-6" fill="currentColor" />
            ) : (
              <BellIcon className="w-6 h-6" fill="currentColor" />
            )}
          </div>
        </Menu>
        {activeWorkspace?.user?.avatar ? (
          <img src={activeWorkspace?.user?.avatar} alt="" className="w-[26px] h-[26px] rounded-md" />
        ) : (
          <div className="w-[26px] h-[26px] rounded-md bg-blue-600 flex items-center justify-center">
            {activeWorkspace?.user?.name[0]}
          </div>
        )}
      </div>
    </div>
  );
};
